import { fromString } from 'foundations-components/transitional/utils/SimpleDate';
import { RANGE_TYPES } from 'FormsUI/constants/DatePresets';
import { URL_DATE_FORMAT } from 'FormsUI/constants/DateFormats';
const LEGACY_DATE_RANGE_MAP = {
  THIS_DAY: RANGE_TYPES.TODAY
};
const getDateRangePreset = presetId => {
  if (presetId === 'THIS_DAY') {
    return LEGACY_DATE_RANGE_MAP[presetId];
  }
  return RANGE_TYPES[presetId];
};
export const getDashboardDateRangeForUrlParams = ({
  dateType,
  startDate,
  endDate
}) => {
  if (startDate && endDate) {
    const formattedStartDate = fromString(startDate, URL_DATE_FORMAT);
    const formattedEndDate = fromString(endDate, URL_DATE_FORMAT);
    if (formattedStartDate && formattedEndDate) {
      return {
        startDate: formattedStartDate,
        endDate: formattedEndDate
      };
    }
  }
  const dateRangePreset = getDateRangePreset(dateType);
  if (dateRangePreset) {
    return {
      type: dateRangePreset.presetId,
      startDate: dateRangePreset.getValue('portalTz').startDate,
      endDate: dateRangePreset.getValue('portalTz').endDate
    };
  }
  return {};
};
export default getDashboardDateRangeForUrlParams;